export * from "./change-password.component";
export * from "./change-password.module";



// WEBPACK FOOTER //
// ./src/app/public/change-password/index.ts